export default {
    STORAGE_KEY: 'P_D_Admin-Key',
    APP_ID: 'P_D_Admin-App',
    CONNECTION_ERROR_MESSAGE: 'We encountered an error. We are working to fix it',
    APP_DESCRIPTION: "Pick&Drop Services Admin Area",
    GOOGLE_API_KEY:"AIzaSyC2wzpyxqSPWfciSs_Y4Ug_4vA97DTAyz8"
};
